import { create } from "zustand";

export type ToastTone = "info" | "success" | "warning" | "error";
export interface AppToast { id: string; message: string; tone: ToastTone; }

interface ToastState {
  toasts: AppToast[];
  push: (message: string, tone?: ToastTone, durationMs?: number) => string;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],
  push: (message, tone = "info", durationMs = 5000) => {
    const id = crypto.randomUUID();
    set((state) => ({ toasts: [...state.toasts, { id, message, tone }].slice(-5) }));
    if (durationMs > 0) window.setTimeout(() => get().dismiss(id), durationMs);
    return id;
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
}));
